import {
  Navigate,
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  generatePath,
} from "react-router-dom";
import RootRoute from "RootRoute";
import Layout from "../layout";
import { APP_URL, DEFAULT_NETWORK } from "../utils/defines";
import { HomePage } from "./HomePage";
//import { LoginPage } from "./LoginPage";
import Template from "./template";
import LoggedInCallbackRoute from "components/LoggedInCallbackRoute";
import ProjectPage from "./project/ProjectPage";
import { HelpPage } from "./help";
import { SatisfactionPage } from "./help/Satisfaction";
import { AccountPage } from "./account";
import MyProjectsPage from "./project/projects/MyProjectsPage";
import LoadProjectPage from "./project/LoadProjectPage";
import StepCompare from "./project/StepCompare/StepCompare";

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<RootRoute />}>
      <Route
        index
        element={
          <Navigate
            to={generatePath(APP_URL.Base, { network: DEFAULT_NETWORK })}
            replace
          />
        }
      />

      <Route path={APP_URL.Loggedin} element={<LoggedInCallbackRoute />} />
      <Route path={APP_URL.Base} element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="home" element={<Navigate to="/" />} />
        {/* <Route path={APP_URL.Login} element={<LoginPage />} /> */}

        <Route path="help/:section?" element={<HelpPage />} />
        <Route path="satisfaction" element={<SatisfactionPage />} />

        <Route path={APP_URL.Account} element={<AccountPage />} />
        <Route path={APP_URL.Clients} element={<AccountPage />} />

        <Route path={APP_URL.Project} element={<ProjectPage />} />
        <Route path={APP_URL.ProjectStep} element={<ProjectPage />} />
        <Route path={APP_URL.LoadProject} element={<LoadProjectPage />} />
        <Route path={APP_URL.MyProjects} element={<MyProjectsPage />} />
        <Route path={APP_URL.CompareProducts} element={<StepCompare />} />
        <Route path={APP_URL.Template}>
          <Route path="" element={<Template />} />
        </Route>
        <Route path="*" element={<Navigate to="/" />} />
      </Route>
    </Route>
  )
);
